/* Dew & Dark — Guides Library client-side filtering.
   Progressive enhancement only: without this file, every card in
   dew-dark-guides-library.liquid is simply visible as a plain grid.
   Load with `defer` in theme.liquid, after dew-dark.css. */
(function () {
  var grid = document.querySelector('[data-dd-library-grid]');
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-dd-hub]'));
  var searchInput = document.querySelector('[data-dd-library-search]');
  var hubSelect = document.querySelector('[data-dd-library-filter="hub"]');
  var speciesSelect = document.querySelector('[data-dd-library-filter="species"]');
  var clearBtn = document.querySelector('[data-dd-library-clear]');
  var countEl = document.querySelector('[data-dd-library-count]');
  var emptyEl = document.querySelector('[data-dd-library-empty]');

  function currentState() {
    return {
      q: (searchInput && searchInput.value.trim().toLowerCase()) || '',
      hub: (hubSelect && hubSelect.value) || 'all',
      species: (speciesSelect && speciesSelect.value) || 'all'
    };
  }

  function applyFilters() {
    var state = currentState();
    var visibleCount = 0;

    cards.forEach(function (card) {
      var matchesHub = state.hub === 'all' || card.getAttribute('data-dd-hub') === state.hub;
      var matchesSpecies = state.species === 'all' || card.getAttribute('data-dd-species') === state.species;
      var matchesSearch = state.q === '' || card.getAttribute('data-dd-search').indexOf(state.q) !== -1;
      var visible = matchesHub && matchesSpecies && matchesSearch;
      card.hidden = !visible;
      if (visible) visibleCount++;
    });

    if (countEl) {
      countEl.textContent = visibleCount + (visibleCount === 1 ? ' guide' : ' guides');
    }
    if (emptyEl) {
      emptyEl.hidden = visibleCount !== 0;
    }

    var params = new URLSearchParams();
    if (state.q) params.set('q', state.q);
    if (state.hub !== 'all') params.set('hub', state.hub);
    if (state.species !== 'all') params.set('species', state.species);
    var query = params.toString();
    var newUrl = window.location.pathname + (query ? '?' + query : '');
    window.history.replaceState(null, '', newUrl);
  }

  function restoreFromUrl() {
    var params = new URLSearchParams(window.location.search);
    if (searchInput && params.has('q')) searchInput.value = params.get('q');
    if (hubSelect && params.has('hub')) hubSelect.value = params.get('hub');
    if (speciesSelect && params.has('species')) speciesSelect.value = params.get('species');
  }

  if (searchInput) searchInput.addEventListener('input', applyFilters);
  if (hubSelect) hubSelect.addEventListener('change', applyFilters);
  if (speciesSelect) speciesSelect.addEventListener('change', applyFilters);
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (searchInput) searchInput.value = '';
      if (hubSelect) hubSelect.value = 'all';
      if (speciesSelect) speciesSelect.value = 'all';
      applyFilters();
    });
  }

  restoreFromUrl();
  applyFilters();
})();
